module.exports = __webpack_public_path__ + "static/media/inbjudan.cb476845.jpg";